/**
 * Stopgap for a Globo Product Options (GPO) bug: choosing a file on a
 * GPO upload field kicks off an async background upload, but nothing in
 * GPO's own widget disables "Add to cart" or shows a "please wait"
 * while that upload is still in flight. Click too soon -- very plausible
 * for a real multi-MB phone photo -- and the click is silently dropped:
 * no error, nothing added to cart, no sign anything went wrong. That is
 * the bug reported to Globo support; this is a defensive stopgap while
 * waiting on their fix, not a patch to their code.
 *
 * This disables the matching "Add to cart" button the moment a file is
 * chosen on a GPO upload field, shows a plain-language "uploading"
 * message next to it, and only re-enables the button when GPO's own
 * "gpoFileSettled" event confirms the upload actually finished. A
 * generous fallback timer guarantees the button is never left stuck
 * disabled, even if GPO renames or stops firing that event in a future
 * update.
 */
(function () {
  var FALLBACK_MS = 30000; // never leave the button disabled longer than this

  function findSubmitButton(form) {
    var buttons = document.querySelectorAll('button[type="submit"]');
    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].form === form) return buttons[i];
    }
    return form ? form.querySelector('button[type="submit"]') : null;
  }

  function ensureStatusEl(input) {
    var id = input.id ? input.id + '-gpo-wait' : null;
    var el = id ? document.getElementById(id) : null;
    if (el) return el;
    el = document.createElement('div');
    if (id) el.id = id;
    el.textContent = 'Uploading your photo, please wait...';
    el.style.cssText = 'margin-top:6px;font-size:1.3rem;color:#666;';
    input.insertAdjacentElement('afterend', el);
    return el;
  }

  function handleFileChange(e) {
    var input = e.target;
    if (!input.matches || !input.matches('input[type="file"][data-type="file"]')) return;
    if (!input.files || input.files.length === 0) return;

    var form = input.form;
    var btn = findSubmitButton(form);
    var statusEl = ensureStatusEl(input);
    if (btn) {
      btn.disabled = true;
      btn.dataset.gpoWaitingForUpload = '1';
    }
    statusEl.style.display = '';

    var done = false;
    function release() {
      if (done) return;
      done = true;
      if (btn && btn.dataset.gpoWaitingForUpload === '1') {
        btn.disabled = false;
        delete btn.dataset.gpoWaitingForUpload;
      }
      statusEl.style.display = 'none';
      input.removeEventListener('gpoFileSettled', release);
    }

    input.addEventListener('gpoFileSettled', release, { once: true });
    setTimeout(release, FALLBACK_MS);
  }

  document.addEventListener('change', handleFileChange, true);
})();
